<template>
  <!--
    メニュー画面のレイアウト

    位置固定のヘッダ、フッタがあり、中央にメニュー一覧配置用のコンテナがあるパターンです。
  -->
  <div class="container">
    <header>
      <div class="content-left">
        <gl-button @click="openPortal" icon-pre="group">
          {{ company }}
        </gl-button>
        <gl-button @click="openPortal" icon-pre="user">
          {{ loginId }}
        </gl-button>
      </div>
      <div class="content-right">
        <md-menu md-direction="bottom-start">
          <md-button md-menu-trigger><gl-icon-help /></md-button>
          <md-menu-content>
            <md-menu-item icon-button @click="moveToHelp">
              <gl-icon-manual />
              <span>マニュアル</span>
            </md-menu-item>
            <md-menu-item icon-button @click="moveToFaq">
              <gl-icon-faq />
              <span>よくある質問</span>
            </md-menu-item>
          </md-menu-content>
        </md-menu>
        <gl-button icon-button @click="logout">
          <md-icon>
            <font-awesome-icon icon="sign-out-alt" />
          </md-icon>
        </gl-button>
      </div>
    </header>

    <main>
      <slot></slot>
    </main>

    <footer>
      <app-footer></app-footer>
    </footer>

    <md-dialog
      :md-active.sync="unreadAnnouncements.length > 0"
      @md-closed="closeAnnouncement"
    >
      <md-dialog-title>お知らせ</md-dialog-title>
      <md-dialog-content @wheel.stop="doThis">
        <div
          v-for="announcement in unreadAnnouncements"
          :key="announcement.id"
          class="announcement"
        >
          <div class="announcement__title">
            {{ announcement.issue_date }}
            {{ announcement.title }}
          </div>
          <div class="announcement__body">
            <pre>{{ announcement.body }}</pre>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <gl-button @click="closeAnnouncement">Close</gl-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import AppFooter from '@/components/common/AppFooter.vue'
import { SET_ACCOUNT } from '@/const/mutation-types'

export default {
  components: { AppFooter },
  data() {
    return {
      // 未読お知らせ
      unreadAnnouncements: [],
    }
  },
  computed: {
    loginId() {
      return this.$store.state.account.loginId
    },
    company() {
      return this.$store.state.companies.map(v => v.name).join(' / ')
    },
  },
  methods: {
    /**
     * ポータルの個人設定ページを開く
     *
     * Giggle側ではアカウント自体の設定は持っていないので。
     */
    openPortal() {
      window.open(
        process.env.VUE_APP_BIZOO_PREFERENCE_URL
          ? process.env.VUE_APP_BIZOO_PREFERENCE_URL
          : 'https://www.cyber-l.co.jp/',
      )
    },
    moveToHelp() {
      window.open(process.env.VUE_APP_HELP_SITE_URL_BASE)
    },
    moveToFaq() {
      window.open(process.env.VUE_APP_FAQ_URL_BASE)
    },
    /**
     * ログアウト
     *
     * アクセストークンによりAPIとやり取りが行われるので、
     * 原則ローカルに保存されている認証情報を全て削除する
     * ことを「ログアウト」と呼びます。
     */
    async logout() {
      await window.ssoClient.signout()
      this.$store.commit(SET_ACCOUNT, {})
      location.reload()
    },
    closeAnnouncement() {
      this.unreadAnnouncements = []
    },
  },
  async created() {
    const repo = this.$repositories.get('announcement')
    const announcements = await repo.get()
    this.unreadAnnouncements = announcements.filter(
      announcement => announcement.unread,
    )
  },
}
</script>

<style lang="scss" scoped>
.container {
  height: calc(100% - 100px);
  display: flex;
  align-items: center;
}

// TODO 今はヘッダとフッタがコンテンツに被らない高さで表示される
//      前提ですが、そうなった場合どうするか要検討です。

header {
  display: flex;
  align-items: center;
  display: flex;
  padding: var(--spacing-large);
  position: fixed;
  top: 0;
  width: 100%;

  .content-left {
    flex: 1;
  }
  .content-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .name {
    display: inline-block;
    font-size: var(--font-size-large);
    margin-left: var(--spacing-medium);
  }
}

main {
  display: flex;
  padding-right: 70px;
  width: max-content;
}

footer {
  bottom: 0;
  position: fixed;
  width: 100%;
}

.announcement {
  &:not(:first-child) {
    margin-top: var(--spacing-medium);
  }
}

.announcement {
  padding: var(--spacing-medium);
  border-radius: 5px;
  border: 1px solid var(--color-border);
  box-sizing: content-box;

  &__title {
    color: var(--color-secondary-text);
    font-size: var(--font-size-normal);
  }

  &__body {
    font-size: var(--font-size-normal);

    pre {
      white-space: pre-wrap;
    }
  }
}
</style>
